import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

export async function countryDeleteApi(payload: RequestDataShape, token: string) {
	const endpoint = "/country/delete/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	await requester.sendRequest(payload, token)
}
